var base = require('settings/teams/team-membership');

Vue.component('spark-team-membership', {
    mixins: [base]
});



// WEBPACK FOOTER //
// ./resources/js/spark-components/settings/teams/team-membership.js